import { render, staticRenderFns } from "./manage-booking-receipt-wrapper.vue?vue&type=template&id=caec1210"
import script from "./manage-booking-receipt-wrapper.vue?vue&type=script&lang=ts"
export * from "./manage-booking-receipt-wrapper.vue?vue&type=script&lang=ts"
import style0 from "./manage-booking-receipt-wrapper.vue?vue&type=style&index=0&id=caec1210&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports